import { useState } from 'react';
import api from '../../services/api.js';
import toast from 'react-hot-toast';

const STEPS = [
  { id: 'welcome',  title: 'Bienvenue sur ELVYRA 🎉', desc: 'Votre plateforme de vidéosurveillance intelligente est prête. Configurons votre première caméra en 3 étapes.' },
  { id: 'camera',   title: 'Créez votre première caméra 📹', desc: 'Donnez un nom et un emplacement à votre caméra.' },
  { id: 'stream',   title: 'Démarrez le stream 📡', desc: 'Votre caméra est prête ! Cliquez sur "Mode Caméra" depuis votre téléphone ou PC pour commencer à streamer.' },
];

export default function OnboardingWizard({ onComplete }) {
  const [step, setStep]     = useState(0);
  const [name, setName]     = useState('');
  const [location, setLoc]  = useState('');
  const [loading, setLoading] = useState(false);
  const [streamKey, setStreamKey] = useState('');

  async function createCamera() {
    if (!name.trim()) return toast.error('Nom requis');
    setLoading(true);
    try {
      const res = await api.post('/devices', { name: name.trim(), location: location.trim() });
      setStreamKey(res.data.data?.streamKey);
      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur');
    } finally { setLoading(false); }
  }

  const current = STEPS[step];

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(6,14,31,0.96)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24,
    }}>
      <div style={{ background: '#0A1628', border: '1px solid #1E3A5F', borderRadius: 16, padding: '40px 36px', maxWidth: 480, width: '100%' }}>

        {/* Progress */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 32 }}>
          {STEPS.map((s, i) => (
            <div key={s.id} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= step ? 'var(--elvyra-accent)' : '#1E3A5F' }} />
          ))}
        </div>

        <h2 style={{ fontSize: 22, fontWeight: 800, margin: '0 0 10px' }}>{current.title}</h2>
        <p style={{ color: '#94A3B8', fontSize: 14, lineHeight: 1.6, margin: '0 0 28px' }}>{current.desc}</p>

        {step === 0 && (
          <button onClick={() => setStep(1)} style={{ width: '100%', padding: '14px', background: 'var(--elvyra-accent)', color: '#060E1F', borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}>
            Commencer →
          </button>
        )}

        {step === 1 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={{ color: '#94A3B8', fontSize: 13, marginBottom: 6, display: 'block' }}>Nom de la caméra *</label>
              <input value={name} onChange={e => setName(e.target.value)} placeholder="Ex : Entrée principale"
                style={{ width: '100%', padding: '10px 14px', background: '#060E1F', border: '1px solid #1E3A5F', borderRadius: 8, color: '#F1F5F9', fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ color: '#94A3B8', fontSize: 13, marginBottom: 6, display: 'block' }}>Emplacement</label>
              <input value={location} onChange={e => setLoc(e.target.value)} placeholder="Ex : Bureau principal"
                style={{ width: '100%', padding: '10px 14px', background: '#060E1F', border: '1px solid #1E3A5F', borderRadius: 8, color: '#F1F5F9', fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            <button onClick={createCamera} disabled={loading || !name.trim()} style={{ padding: '14px', background: 'var(--elvyra-accent)', color: '#060E1F', borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 15, cursor: 'pointer', opacity: name.trim() ? 1 : 0.5 }}>
              {loading ? 'Création...' : 'Créer la caméra →'}
            </button>
          </div>
        )}

        {step === 2 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ background: '#060E1F', borderRadius: 10, padding: '16px', border: '1px solid #1E3A5F' }}>
              <p style={{ color: '#64748B', fontSize: 12, margin: '0 0 6px' }}>Clé de flux (pour configuration avancée)</p>
              <code style={{ color: 'var(--elvyra-accent)', fontSize: 12, wordBreak: 'break-all' }}>{streamKey}</code>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <p style={{ color: '#94A3B8', fontSize: 13, margin: 0 }}>
                ✅ Caméra créée !<br/>
                Ouvrez maintenant <strong style={{ color: 'var(--elvyra-accent)' }}>Mode Caméra</strong> sur votre téléphone pour démarrer la surveillance.
              </p>
            </div>
            <button onClick={onComplete} style={{ padding: '14px', background: 'var(--elvyra-accent)', color: '#060E1F', borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>
              Accéder au Dashboard →
            </button>
          </div>
        )}

        {step > 0 && step < 2 && (
          <button onClick={() => setStep(s => s - 1)} style={{ width: '100%', marginTop: 12, padding: '10px', background: 'transparent', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 13 }}>
            ← Retour
          </button>
        )}
      </div>
    </div>
  );
}
